export interface EQRevisionDocument {
  // --- DB Properties
  uid: number;
  guid: string;
  companyUID: number;
  departmentUID: number; // 부서 UID
  writerUID: number; // 작성자 UID
  type: number; // 0 - 작업성평가 , 1- 가동전점검
  name: string; // 작업명
  serialNo: number | null; // Part No - 일련번호
  revisionNo: number; // 개정 번호
  firstDate: Date | string; // 최초 평가일
  lastDate: Date | string; // 최근 개정일
  extra: string; // 비고
  fileName: string; // 파일명
  extension: string; // 확장자
  fileType: number; // Deprecated  파일 형식

  additionalFile1: string; // 추가 파일명 1
  additionalFile2: string; // 추가 파일명 2
  isDeleted: boolean;

  entryDate: Date | string;

  // NOT DB
  base64: string;
  addtional1Base64: string;
  addtional2Base64: string;
}

export const initializeRevisionDocument = (type: number = 0): EQRevisionDocument => {
  return {
    uid: 0,
    guid: "00000000-0000-0000-0000-000000000000",
    companyUID: 0,
    departmentUID: 0,
    writerUID: 0,
    type: type,
    name: "",
    serialNo: 0,
    revisionNo: 0,
    firstDate: new Date(),
    lastDate: new Date(),
    extra: "",
    fileName: "",
    extension: "",
    fileType: 0,

    additionalFile1: "",
    additionalFile2: "",

    isDeleted: false,
    entryDate: new Date(),

    base64: "",
    addtional1Base64: "",
    addtional2Base64: "",
  };
};
export interface RevisionDocumentListParams {
  id: number;
  page: number;
  token: string;
  rows?: number; // 표시 행 수
}

export const initializeRevisionDocumentListParams = {
  id: 0,
  page: 1,
  token: "",
  rows: 20, // 표시 행 수
};
export const revisionTypeNames = ["작업위험성평가", "가동전점검"];
